import Button from "@/components/button/Button"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { loadCalendly } from "@/helpers/thirdPartyScripts"
import { trackEvent } from "@/hooks/useGoogleAnalytics"
import { websiteRoutes } from "@/router/routes"
import { EASETECH, globalColors } from "@/utilities/global-variables"
import { FC, useEffect } from "react"
import { useNavigate } from "react-router"

const { Text } = WebsiteTypography

type Props = {
  type?: "orange" | "darkBlue"
  block?: boolean
}

declare global {
  interface Window {
    Calendly: any
  }
}

const BookDemoButton: FC<Props> = ({ type = "orange", block = false }) => {
  const navigate = useNavigate()
  const { website } = websiteRoutes

  useEffect(() => {
    const handleCalendlyEvent = (event: MessageEvent) => {
      if (event.origin !== "https://calendly.com") return
      if (event.data?.event !== "calendly.event_scheduled") return

      navigate(`/${EASETECH}${website.thankYouPage}`)
    }

    window.addEventListener("message", handleCalendlyEvent)

    return () => {
      window.removeEventListener("message", handleCalendlyEvent)
    }
  }, [])

  const handleBookDemoBtn = () => {
    // Calendly loads after the page goes idle; a click before that loads it now.
    loadCalendly()
      .then(
        () =>
          window.Calendly?.initPopupWidget({
            url: "https://calendly.com/easetech-info/30min?background_color=0f2745&text_color=ffffff&primary_color=ff6600",
          })
      )
      .catch(() => console.error("Calendly script is not loaded"))
    // Track button click event
    trackEvent("Book a demo banner", "Book a demo click", "book-demo-button")
  }

  return (
    <Button
      onClick={handleBookDemoBtn}
      size={"large"}
      style={{ backgroundColor: type === "darkBlue" ? globalColors?.defaultPrimaryColor : undefined, zIndex: 3 }}
      block={block}
    >
      <Text size={"md"}> {"BOOK A DEMO"}</Text>
    </Button>
  )
}

export default BookDemoButton
